import { render } from "./cjabnormalCall.vue?vue&type=template&id=a4fe0d78&scoped=true"
import script from "./cjabnormalCall.vue?vue&type=script&lang=js"
export * from "./cjabnormalCall.vue?vue&type=script&lang=js"

import "./cjabnormalCall.vue?vue&type=style&index=0&id=a4fe0d78&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a4fe0d78"

export default script